import { Component, Input } from "@angular/core";

@Component({
    selector: "adapt-incomplete-work",
    templateUrl: "./incomplete-work.component.html",
    styleUrl: "./incomplete-work.component.css",
    standalone: false,
})
export class IncompleteWorkComponent {
    @Input() public message?: string;
}
